module.exports = __webpack_public_path__ + "static/media/redesign-logo.d7fa2f02.png";